module.exports = __webpack_public_path__ + "static/media/thumbnail.eab6c940.webp";